import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DatePicker from "react-datepicker";
import {
  Delete,
  Visibility,
  Download,
  PagesRounded,
  ShieldMoon,
} from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import "../../assets/scss/styles/timeline.css";

function PreChallan(props) {
  const [piData, setPiData] = useState([]);
  const [status, setStatus] = useState("");
  const [storeStatus, setStoreStatus] = useState("");
  const [note, setNote] = useState("");
  const [readNote, setReadNote] = useState("");
  const [dispatchDate, setdispatchDate] = useState(new Date());
  const [storeNote, setStoreNote] = useState("");
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1200);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1200);
  const [loadingAccept, setLoadingAccept] = useState(false); // State to manage loading for Accept button
  const [loadingReject, setLoadingReject] = useState(false);
  const [errors, setErrors] = useState({});
  const [storeErrors, setStoreErrors] = useState({});

  const dispatch = useDispatch();
  const fields = [
    { label: "Delivery Note No.", key: "deliverynoteno" },
    { label: "Dated", key: "delivery_note_date" },
    { label: "", key: "" },
    { label: "Mode/Terms of Payment", key: "payment_terms" },
    { label: "Reference No. & Date.", key: "ref_no_date" },
    { label: "Other References", key: "other_ref" },
    { label: "Buyer’s Order No.", key: "buyers_order_no" },
    { label: "Dated", key: "buyers_order_date" },
    { label: "Dispatch Doc No.", key: "dispacth_doc_no" },
    { label: "", key: "" },
    { label: "Dispatched through", key: "dispatched_through" },
    { label: "Destination", key: "destination" },
    { label: "Bill of Lading/LR-RR No.", key: "bill_of_landing_lr_rr_no" },

    { label: "Motor Vehicle No.", key: "motor_vehicle_no" },
  ];

  const discounts = [
    {
      key: "quantity_discount_per",
      value: "quantity_discount",
      label: "Quantity Discount",
      extra: "Less:",
    },
    {
      key: "cash_discount_per",
      value: "cash_discount",
      label: "Cash Discount",
      extra: "Less:",
    },
    {
      key: "special_discount_per",
      value: "special_discount",
      label: "Special Discount",
      extra: "Less:",
    },
    {
      key: "freight_amount",
      value: "freight_amount",
      label: "Freight Amount",
      extra: "",
    },
    {
      key: "insurance_per",
      value: "insurance_amount",
      label: "Insurance",
      extra: "",
    },
    { key: "igst_per", value: "igst", label: "IGST", extra: "" },
    { key: "sgst_per", value: "sgst", label: "SGST", extra: "" },
    { key: "cgst_per", value: "cgst", label: "CGST", extra: "" },
    { key: "rounding", label: "Rounding", extra: "Less", value: "roundoff" },
  ];

  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );

  const isSalesCoordinator = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Sales_Coordinator_permissions"
  );

  const isStoreManager = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Store_Manager_permissions"
  );

  const activeUser = userProfile?.user_role[0]?.roleName;

  const userId = userProfile?.id;
  const rowData = props?.rowData;
  const isRelevantUser =
    userId === rowData?.ceo_id ||
    userId === rowData?.cfo_id ||
    userId === rowData?.rsm_id ||
    userId === rowData?.channel_partner_id;

  // const IsRsm = activeUser === "Regional Sales Manager";
  // const IsCfo = activeUser === "Regional Sales Manager";
  // const IsCeo = activeUser === "Regional Sales Manager";

  const approvalNoteKeys = [
    { key: "rsm_approve_note", label: "RSM Note", id: rowData?.rsm_id },
    {
      key: "channel_partner_approve_note",
      label: "Channel Partner Note",
      id: rowData?.channel_partner_id,
    },
    { key: "cfo_approve_note", label: "CFO Note", id: rowData?.cfo_id },
    { key: "ceo_approve_note", label: "CEO Note", id: rowData?.ceo_id },
  ];

  const isApprovalStatusZero = () => {
    if (userId === rowData?.ceo_id) {
      return rowData?.ceo_approve_status === "0";
    } else if (userId === rowData?.cfo_id) {
      return rowData?.cfo_approve_status === "0";
    } else if (userId === rowData?.rsm_id) {
      return rowData?.rsm_approve_status === "0";
    } else if (userId === rowData?.channel_partner_id) {
      return rowData?.channel_partner_approve_status === "0";
    }
    return false;
  };

  const isApprovalStatusRejected = () => {
    if (userId === rowData?.ceo_id) {
      return rowData?.ceo_approve_status === "2";
    } else if (userId === rowData?.cfo_id) {
      return rowData?.cfo_approve_status === "2";
    } else if (userId === rowData?.rsm_id) {
      return rowData?.rsm_approve_status === "2";
    } else if (userId === rowData?.channel_partner_id) {
      return rowData?.channel_partner_approve_status === "2";
    }
    return false;
  };

  const getApprovalNote = () => {
    if (userId === rowData?.rsm_id && rowData?.rsm_approve_note !== null) {
      console.log(rowData?.rsm_approve_note, "This is ta");
      return rowData?.rsm_approve_note;
    } else if (
      userId === rowData?.channel_partner_id &&
      rowData?.channel_partner_approve_note !== null
    ) {
      return rowData?.channel_partner_approve_note;
    } else if (
      userId === rowData?.cfo_id &&
      rowData?.cfo_approve_note !== null
    ) {
      return rowData?.cfo_approve_note;
    } else if (
      userId === rowData?.ceo_id &&
      rowData?.ceo_approve_note !== null
    ) {
      return rowData?.ceo_approve_note;
    }
    return "";
  };

  // Use useEffect to set the note state based on the approval note
  useEffect(() => {
    const approvalNote = getApprovalNote();

    setReadNote(approvalNote);
  }, [userId, rowData]);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1200);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1200);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getPiData();
  }, []);

  const getPiData = () => {
    const orderId =
      props?.rowData?.orderdata && props?.rowData?.orderdata.id
        ? props?.rowData?.orderdata.id
        : props?.rowData?.id;
    utils
      .callAPI("get", `/sales/getInvoiceList?id=${orderId}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setPiData(res);
        } else {
          setPiData([]);
        }
      })
      .catch((err) => {
        setPiData([]);
      });
  };

  const handleBackClick = (e) => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleDownload = () => {
    // window.open(
    //   `http://tms.vura.ae/dev/Vura_API_Server/src/api/sales/pi_download/${props.rowData?.id}`,
    //   "_blank"
    // );

    utils
      .callAPI("get", `/sales/download_challan/${piData?.id}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          window.open(res, "_blank");
        } else {
          //setPiData([]);
        }
      })
      .catch((err) => {
        // setPiData([]);
      });
  };

  const sendStatus = (type) => {
    if (type === "accept") {
      setLoadingAccept(true); // Start loader for Accept button
    } else {
      setLoadingReject(true); // Start loader for Reject button
    }

    var bodyFormData = new FormData();
    if (status !== "") {
      bodyFormData.append("id", props?.rowData?.id);
      bodyFormData.append("status", status);
      bodyFormData.append("remarks", note);
      utils
        .callAPI(
          "post",
          `${
            piData.store_location_approve_status === "1"
              ? "/sales/approve_pi_dispatch_by_sco"
              : "/sales/approve_pi_by_reporting_manager"
          }`,
          bodyFormData
        )
        .then((res) => {
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader for Accept button
          } else {
            setLoadingReject(false); // Stop loader for Reject button
          }

          if (typeof res !== "undefined") {
            Swal.fire({
              title: "Success!",
              text:
                status === "1"
                  ? "The invoice has been accepted."
                  : "The invoice has been rejected.",
              icon: "success",
              confirmButtonText: "OK",
            });

            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            // Handle undefined response
          }
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: "There was an error processing your request.",
            icon: "error",
            confirmButtonText: "OK",
          });
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader on error for Accept button
          } else {
            setLoadingReject(false); // Stop loader on error for Reject button
          }

          // Handle error
        });
    }
  };

  const sendStoreStatus = (type) => {
    if (type === "accept") {
      setLoadingAccept(true); // Start loader for Accept button
    } else {
      setLoadingReject(true); // Start loader for Reject button
    }

    var bodyFormData = new FormData();
    if (storeStatus !== "") {
      bodyFormData.append("id", props?.rowData?.id);
      bodyFormData.append("status", storeStatus);
      bodyFormData.append("remarks", storeNote);
      bodyFormData.append(
        "dispatch_date",
        moment(dispatchDate).format("YYYY-MM-DD")
      );
      utils
        .callAPI("post", `/sales/approve_pi_by_store_location`, bodyFormData)
        .then((res) => {
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader for Accept button
          } else {
            setLoadingReject(false); // Stop loader for Reject button
          }

          if (typeof res !== "undefined") {
            Swal.fire({
              title: "Success!",
              text:
                storeStatus === "1"
                  ? "The Order has been accepted."
                  : "The Order has been rejected.",
              icon: "success",
              confirmButtonText: "OK",
            });

            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            // Handle undefined response
          }
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: "There was an error processing your request.",
            icon: "error",
            confirmButtonText: "OK",
          });
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader on error for Accept button
          } else {
            setLoadingReject(false); // Stop loader on error for Reject button
          }

          // Handle error
        });
    }
  };

  useEffect(() => {
    // If there are no validation errors and status is set, call sendStatus
    if (status === "1" || status === "2") {
      if (status === "1") {
        sendStatus("accept");
      } else if (status === "2") {
        sendStatus("reject");
      }
    }
  }, [status, note]);

  useEffect(() => {
    // If there are no validation errors and status is set, call sendStatus
    if (storeStatus === "1" || storeStatus === "2") {
      if (storeStatus === "1") {
        sendStoreStatus("accept");
      } else if (storeStatus === "2") {
        sendStoreStatus("reject");
      }
    }
  }, [storeStatus, storeNote]);

  const handleAccept = () => {
    setStatus("1");
  };

  const handleReject = (e) => {
    // handleRejectChange("reject");
    const validationErrors = validate();
    setErrors(validationErrors);

    if (note !== "") setStatus("2");
  };

  const handleStoreAccept = () => {
    setStoreStatus("1");
  };

  const handleStoreReject = (e) => {
    // handleRejectChange("reject");
    const validationErrors = storeValidate();
    setStoreErrors(validationErrors);

    if (storeNote !== "") setStoreStatus("2");
  };

  const storeValidate = () => {
    const newErrors = {};
    if (!storeNote) {
      newErrors.storeNote = "Note is required";
    }
    return newErrors;
  };

  const validate = () => {
    const newErrors = {};
    if (!note) {
      newErrors.note = "Comment is required";
    }
    return newErrors;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Update the corresponding state based on the input name
    if (name === "note") {
      setNote(value);
      console.log(errors, "yeh hai");
      // Clear validation error for the 'note' field when user starts typing
      setErrors((prevErrors) => ({
        ...prevErrors,
        note: value ? "" : prevErrors.note,
      }));
    }
  };

  const handleStoreInputChange = (e) => {
    const { name, value } = e.target;

    // Update the corresponding state based on the input name
    if (name === "storeNote") {
      setStoreNote(value);

      setStoreErrors((prevErrors) => ({
        ...prevErrors,
        storeNote: value ? "" : prevErrors.storeNote,
      }));
    }
  };

  return (
    <div className="section-body">
      <RB.Card className="card ">
        <RB.Card.Header className="border-0">
          <h4>Delivery Note</h4>
          <div className="card-header-action">
            <RB.Button className="btn btn-light me-2" onClick={handleDownload}>
              Download
            </RB.Button>
            <RB.Button className="btn btn-light" onClick={handleBackClick}>
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body className="p-2 p-md-3">
          <div className="border">
            <RB.Row className="g-0">
              <RB.Col md={7} className="border-end">
                <div className="ms-2 border-bottom">
                  <strong>
                    {" "}
                    {piData?.location_data?.name}{" "}
                    {`(${piData?.location_data?.city})`}
                  </strong>
                  <br />
                  {piData?.location_data?.address}
                  <br />
                  {piData?.location_data?.state} -{" "}
                  {piData?.location_data?.pincode} <br />
                  GSTIN/UIN: {piData?.gst_uni} <br />
                  State Name: {piData?.location_data?.state}, Code : 08 <br />
                  E-Mail : {piData?.location_data?.contact_person_email}
                </div>
                {/* <hr className="m-0 p-0" /> */}
                <div className="mt-1 ms-2 border-bottom">
                  <span>Consignee (Ship to)</span>
                  <br />
                  <strong>{piData?.ship_to_companyName}</strong>
                  <br />
                  {piData?.ship_to_company_address},{" "}
                  {piData?.ship_to_company_city}
                  <br />
                  {piData?.ship_to_company_state} -{" "}
                  {piData?.ship_to_company_pincode} <br />
                  GSTIN/UIN: {piData?.ship_to_gst_no} <br />
                  State Name: {piData?.ship_to_company_state}, Code : 08 <br />
                </div>
                {/* <hr className="m-0 p-0" /> */}
                <div className="mt-1 ms-2">
                  <span>Buyer (Bill to)</span>
                  <br />
                  <strong>{piData?.ship_to_companyName}</strong>
                  <br />
                  {piData?.ship_to_company_address},{" "}
                  {piData?.ship_to_company_city}
                  <br />
                  {piData?.ship_to_company_state} -{" "}
                  {piData?.ship_to_company_pincode} <br />
                  GSTIN/UIN: {piData?.ship_to_gst_no} <br />
                  State Name: {piData?.ship_to_company_state}, Code : 08 <br />
                </div>
              </RB.Col>

              <RB.Col md={5}>
                <RB.Row className="g-0 row-devided-2">
                  {fields.slice(0, 6).map((field, index) => (
                    <>
                      <div
                        key={index}
                        className={`col-6 ps-1 border-bottom ${
                          isSmallScreen ? "invoice-border" : ""
                        }`}
                      >
                        <span className="text-uppercase fw-bold small text-body-secondary ps-1">
                          {field.label}
                        </span>
                        <p className="fw-medium text-sm fw-semibold ps-1">
                          {piData?.[field.key] || " "}
                        </p>
                      </div>
                      {/* <hr className="m-0 p-0" /> */}
                    </>
                  ))}

                  {fields.slice(6, 12).map((field, index) => (
                    <>
                      <div
                        key={index}
                        className={`col-6 ps-1 border-bottom ${
                          isSmallScreen ? "invoice-border" : ""
                        }`}
                      >
                        <span className="text-uppercase fw-bold small text-body-secondary ps-1">
                          {field.label}
                        </span>
                        <p className="fw-medium text-sm fw-semibold ps-1">
                          {field.label === "Dated" ||
                          field.label === "Delivery Note Date"
                            ? moment(piData?.[field.key]).format("D-MMM-YYYY")
                            : piData?.[field.key] || " "}
                        </p>
                      </div>
                      {/* <hr className="m-0 p-0" /> */}
                    </>
                  ))}
                </RB.Row>

                <div className="">
                  <div>
                    <div
                      className={`${isSmallScreen ? "invoice-border" : "ps-2"}`}
                    >
                      <span className="text-uppercase fw-bold small text-body-secondary ">
                        Terms of Delivery
                      </span>
                      <p className="fw-medium text-sm fw-semibold">
                        {piData?.delivery_terms || " "}
                      </p>
                    </div>
                  </div>
                </div>
              </RB.Col>
            </RB.Row>
          </div>
          <RB.Table
            responsive
            bordered
            hover
            striped
            className="invoice-table border mb-0"
          >
            <thead>
              <tr>
                <th>SI No.</th>
                <th className="text-center">Description of goods</th>
                <th className="text-center">Qty</th>
              </tr>
            </thead>
            <tbody>
              {piData.Proforma_invoice_products?.map((product, index) => (
                <tr key={index}>
                  <td>{index + 1}</td> {/* Sr No. starts from 1 */}
                  <td>
                    {product.product_name}
                    <br />
                  </td>
                  <td className="text-end">
                    <span className="fw-medium text-sm fw-semibold ms-1">
                      {`${product.qty} Bag` || " "}
                    </span>
                    <br />
                    <span>{`(${product.size * product.qty} ${
                      product.unit
                    })`}</span>
                  </td>
                </tr>
              ))}

              <tr>
                <td />
                <td className="text-end ">
                  <span>Total </span>
                </td>
                <td className="text-end">
                  <span className="fw-medium text-sm fw-semibold ms-1">
                    {`${piData.toatl_qty} Kg` || " "}
                  </span>
                </td>
              </tr>
            </tbody>
            {/* <tfoot>
              <tr>
                <td className="justify-content-between">
                  <span>Amount Chargeable (in words)</span>
                </td>
                <td colSpan={6} className="text-end">
                  <span>E. & O.E</span>
                </td>
              </tr>
              <tr>
                <td colSpan={12}>
                  <strong>{piData?.amount_in_word}</strong>
                </td>
              </tr>

              <tr>
                <td colSpan={2} className="border-end">
                  <span className="mt-1"> Declaration </span>
                  <br />
                  <span className="mb-1">
                    We declare that this invoice shows the actual price of the
                    goods
                    <br /> described and that all particulars are true and
                    correct.
                  </span>
                </td>

                <td colSpan={6} className="border-top border-left solid g-3">
                  <div className="text-end">
                    <strong>
                      for {piData?.location_data?.name}{" "}
                      {`(${piData?.location_data?.city})`}
                    </strong>
                    <br />
                    <span>Authorised Signatory</span>
                  </div>
                </td>
              </tr>
            </tfoot> */}
          </RB.Table>

          <div className="border mb-3">
            <RB.Row className="justify-content-between ms-1 me-1 mb-5 pb-5">
              <RB.Col className="text-end">
                <span>E. & O.E</span>
              </RB.Col>
            </RB.Row>

            <RB.Row className="ms-1 me-1 mt-3 row-cols-1 row-cols-sm-2 ">
              <RB.Col className="border-top border-end-sm">
                {" "}
                <span className="mt-1"> Recd. in Good Condition </span>
                <br />
              </RB.Col>

              <RB.Col className="border-top mt-2 mt-sm-0 ">
                <div className="text-end">
                  <strong>
                    for {piData?.location_data?.name}{" "}
                    {`(${piData?.location_data?.city})`}
                  </strong>
                  <br />
                  <br />
                  <span className="">Authorised Signatory</span>
                </div>
              </RB.Col>
            </RB.Row>
          </div>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default PreChallan;
